//Library Imports
import { useCookies } from "react-cookie";
import { useState } from "react";
import { connect, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Reaptcha from "reaptcha";

// application components goes here
import Button from "../../../Common/Components/Button";
import Checkbox from "../../../Common/Components/Checkbox";
import Input from "../../../Common/Components/Input";
import Message from "../../../Common/Components/Message";
import { validateLoginFields, formatLoginData } from "../../Utils";
import { CAPTCHA_SITE_KEY } from "../../../../constants/index";
import User from "./User";
import { getLoginService } from "../../action";
import { RootState } from "../../../../store/index";
import { IErrorsState, IUser } from "../Interfaces";
import { USER_FIRSTNAME, USER_LASTNAME, USER_EMAIL, USER_APPNAME, ACCESS_ID } from "../../../../constants/index";
import { setCSRFToken } from "../../../../utils";

// styles goes here
import styled from "styled-components";
import GlobalStyle from "../../../../GlobalStyle";

type LoginContainerProps = { setRedirectPath: (val: string) => void };

const LoginContainer: React.FC<LoginContainerProps> = (props: LoginContainerProps) => {
  const user: IUser = useSelector((state: RootState) => state.user.userData);
  const [cookies, setCookies, removeCookies] = useCookies([]);
  const [cookieEmail, setCookieEmail] = useState(cookies["email"] ? cookies["email"] : "");
  const [email, setEmail] = useState(cookies["email"] ? cookies["email"] : "");
  const [password, setPassword] = useState("");

  // check if the user is first time logging it from localstorage
  const [rememberMe, setRememberMe] = useState(localStorage.getItem("rememberMe") === "true");
  const [showPassword, togglePassword] = useState(false);
  const [message, setMessage] = useState({
    status: true,
    message: "",
  });
  const [showEmailRememberMe, setShowEmailRememberMe] = useState(false);
  const [captcha, setCaptcha] = useState("");
  const [captchaStatus, setCaptchaStatus] = useState(1);
  const [captchaValue, setcaptchaValue] = useState("");
  const [errors, setErrors] = useState<IErrorsState>({});
  const [showCaptcha, setShowCaptcha] = useState(false);
  //* adding ref for reaptcha to reset it - Need to be done with better approach
  let reaptchaRef: any = null;

  // loading
  const [loading, setLoading] = useState(false);

  let history = useHistory();

  // verifies captcha
  const onVerify = (recaptchaResponse: string) => {
    setCaptcha("");
    setcaptchaValue(recaptchaResponse);
    setMessage({ status: true, message: "" });
    if (errors.captcha) {
      console.log("inside else erroer");
      let errorsObject = { ...errors };
      delete errorsObject.email;
      setErrors(errorsObject);
    }
  };

  const onExpire = () => {
    setcaptchaValue("");
    setMessage({ status: false, message: "Please resolve captcha" });
  };

  //handles login fields and calls service
  function handleLogin() {
    const validationMessage = validateLoginFields(captchaValue, email, showCaptcha, password);
    if (!validationMessage.status) {
      setMessage(validationMessage);
      setErrors(validationMessage.errors);
    } else {
      setMessage({
        status: true,
        message: "",
      });
      callLoginAPI(formatLoginData(email, password, true));
    }
  }

  // Remove cookies for remember me
  function handleKnownUser() {
    setShowEmailRememberMe(true);
    // don't remove the cookies instead show the email field with the email address
  }

  // validates if user has logged in for first time to run onboarding
  function handleFirstLoginUser(response: any) {
    let now = new Date();
    let year = now.getFullYear();
    let month = now.getMonth();
    let day = now.getDate();
    let cookieExpiry = new Date(year + 1, month, day);
    if (window.location.hostname === "localhost") {
      setCookies("isLogout", "0", {
        path: "/",
        expires: cookieExpiry,
        domain: "localhost",
      });
    }
    if (response.first_login_workbench === 1) {
      history.push("/welcome");
    } else {
      if (response.appName !== "workbench" && response.appName !== "xiQ WB") {
        history.push("/content/explorer"); // redirecting to smart content tab as of WB 4.0 requirments
      } else {
        history.push("content/explorer");
      }
    }
  }

  // calls login api to log in user
  function callLoginAPI(formData: FormData) {
    setLoading(true);
    if (showCaptcha) {
      reaptchaRef.reset();
    }
    getLoginService(formData)
      .then((response) => {
        if (response.status === "True") {
          user.isAuthenticated = true;
          setCSRFToken(response.csrf_token);
          setCookies("appName", USER_APPNAME);
          localStorage.setItem("username", USER_EMAIL);
          if (rememberMe) {
            setCookies("email", USER_EMAIL);
            setCookies("firstName", USER_FIRSTNAME);
            setCookies("lastName", USER_LASTNAME);
            localStorage.setItem("rememberMe", "true");
          } else {
            removeCookies("email");
            removeCookies("firstName");
            removeCookies("lastName");
            localStorage.setItem("rememberMe", "false");
          }
          handleFirstLoginUser(response);
        } else if (response.status === "False" || response.status === false) {
          setMessage({ status: false, message: response.message });
          setLoading(false);
          setcaptchaValue("");
        } else {
          setLoading(false);
          setcaptchaValue("");
        }
      })
      .catch((err) => {
        setLoading(false);
        setcaptchaValue("");
      });
  }

  return (
    <>
      <GlobalStyle />
      <LoginWrapper>
        <h2>Login to Workbench</h2>
        {!message.status ? <Message type="error" label="Error!" message={message.message} /> : ""}
        {cookieEmail && showEmailRememberMe == false ? (
          <User
            onClick={() => {
              handleKnownUser();
              props.setRedirectPath("");
            }}
            label={
              cookies["firstName"] && cookies["lastName"]
                ? cookies["firstName"] + " " + cookies["lastName"]
                : cookieEmail
            }
            //* Commenting the following line as for removing the image on login screen for cookied user
            // pic="https://xiq-email-static.s3-us-west-2.amazonaws.com/11ceb038bdae4b28975b1ab9d0a00a0c/lib/pluginId_11ceb038bdae4b28975b1ab9d0a00a0c_user_7450/20291619082896512.png"
          />
        ) : (
          <Input
            value={email}
            className=""
            name="email"
            type="text"
            label="Email"
            error={errors.email}
            placeholder="Enter your email address…"
            onFocus={() => {
              if (errors.email) {
                let errorsObject = { ...errors };
                delete errorsObject.email;
                setErrors(errorsObject);
              }
            }}
            onChange={(e: React.FormEvent<HTMLInputElement>) => {
              setEmail(e.currentTarget.value);
            }}
          />
        )}

        <Input
          value={password}
          className="password padding-right-password"
          is_password="true"
          name="Password"
          error={errors.password}
          label="Password"
          type={showPassword ? "text" : "password"}
          placeholder="Enter your password…"
          togglePassword={(e: EventListener) => togglePassword(!showPassword)}
          onFocus={() => {
            if (errors.password) {
              let errorsObject = { ...errors };
              delete errorsObject.password;
              setErrors(errorsObject);
            }
          }}
          onChange={(e: React.FormEvent<HTMLInputElement>) => {
            setPassword(e.currentTarget.value);
            if (errors.password) {
              let errorsObject = { ...errors };
              delete errorsObject.password;
              setErrors(errorsObject);
            }
            if (!message.status) {
              setMessage({ status: true, message: "" });
            }
          }}
        />
        <label className="remember-login">
          <Checkbox
            checked={rememberMe}
            onChange={(e: React.FormEvent<HTMLInputElement>) => setRememberMe(!rememberMe)}
          />
          Remember me next time I log in
        </label>
        <Button value={loading ? "Loading..." : "Log in now"} disabled={loading} onClick={handleLogin} />

        {captchaStatus && showCaptcha ? (
          <div className="mt-3">
            <div className="col-12 mb-1 pl-0 mt-2">
              <Reaptcha
                ref={(e) => (reaptchaRef = e)}
                sitekey={CAPTCHA_SITE_KEY}
                onVerify={onVerify}
                onExpire={onExpire}
              />
            </div>
            {captcha && (
              <div className="col-12 mt-2 p-0">
                <div className="text-danger">{captcha}</div>
              </div>
            )}
          </div>
        ) : null}
        <p>
          Did you forget your
          <span className="span" onClick={(e) => props.setRedirectPath("username")}>
            username
          </span>
          or
          <span className="span me-0" onClick={(e) => props.setRedirectPath("password")}>
            password
          </span>
          ?
        </p>
      </LoginWrapper>
    </>
  );
};

export default connect()(LoginContainer);

const LoginWrapper = styled.div`
  margin: 0px;
  padding: 0px 60px;
  border-radius: 30px;
  background-color: #fff;
  display: block;
  width: 100%;
  @media all and (max-width: 1439px), all and (max-height: 749px) {
    padding: 0px 40px;
    border-radius: 21px;
    max-width: 350px;
  }
  h2 {
    color: #424b50;
    font-size: 32px;
    margin: 35px 0 10px 0;
    font-weight: 800;
    text-align: left;
    font-family:'Roboto Slab', serif;
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      font-size: 26px;
      margin: 25px 0 10px 0;
    }
  }
  .padding-right-password {
    padding-right: 2.2em !important;
  }
  label.remember-login {
    color: #7e7e7e;
    font-size: 16px;
    font-weight: 500;
    display: block;
    padding: 25px 0 30px 0;
    margin: 0px;
    font-family: "robotomedium";
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      padding: 16px 0 16px 0;
      font-size: 12px;
    }
  }
  p {
    font-size: 16px;
    color: #5e7079;
    margin: 27px 0;
    font-family: "robotoregular";
    font-weight: 600;
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      margin: 16px 0;
      font-size: 12px;
    }
    a {
      color: #27ce0a !important;
      font-weight: 700;
      text-decoration: none;
    }
    .span {
      margin: 0px 5px;
      cursor: pointer;
      color: #27ce0a !important;
      font-weight: 700;
      text-decoration: none;
    }
  }
  button {
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      font-size: 16px;
      padding: 8px 18px;
    }
  }
  label {
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      margin: 16px 0 5px 0;
      font-size: 12px;
    }
  }
  input[type="text"],
  input[type="password"] {
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      font-size: 16px;
      line-height: 20px;
      padding: 8px 18px;
      &.password + span {
        top: 13px;
      }
    }
  }
  .g-recaptcha > div {
    height: 85px !important;
    div > iframe {
      height: 85px !important;
    }
  }
`;
